import React from 'react';
import { Button } from 'react-bootstrap';

const BarraAcoes = ({ selecionados, onEnviar, onExcluir, onGerenciarMensagens, enviando }) => (
  <div
    className="d-flex align-items-center py-2 px-3 border-top"
    style={{ background: '#f8f9fa', gap: 8 }}
  >
    <Button
      variant="primary"
      onClick={onEnviar}
      disabled={!selecionados || selecionados.length === 0 || enviando}
    >
      {enviando ? 'Enviando...' : `Enviar SMS Selecionados (${selecionados ? selecionados.length : 0})`}
    </Button>
    <Button
      variant="danger"
      onClick={onExcluir}
      disabled={!selecionados || selecionados.length === 0}
    >
      Excluir Selecionados
    </Button>
    <Button variant="outline-secondary" onClick={onGerenciarMensagens}>
      Gerenciar Mensagens
    </Button>
  </div>
);

export default BarraAcoes;
